import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useEscapeKey } from '../../../app/hooks/useEscapeKey';
import { useBodyScrollLock } from '../../../app/hooks/useBodyScrollLock';
interface SlideOverProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: React.ReactNode;
  children?: ReactNode;
  width?: 'sm' | 'md' | 'lg';
}
export function SlideOver({
  open,
  onClose,
  title,
  description,
  children,
  width = 'md'
}: SlideOverProps) {
  const widthClass = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg'
  }[width];
  useEscapeKey(onClose, open);
  useBodyScrollLock(open);
  return <AnimatePresence data-id="element-4672">
      {open && <div className="fixed inset-0 z-50 overflow-hidden" data-id="element-4673">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-4674" />

          {/* Panel */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className={`absolute inset-y-0 right-0 flex flex-col w-full ${widthClass} bg-white shadow-2xl`} data-id="element-4675">
            {/* Header */}
            <div className="flex items-start justify-between px-5 py-4 border-b border-gray-100 flex-shrink-0" data-id="element-4676">
              <div data-id="element-4677">
                <h2 className="text-base font-semibold text-gray-900" data-id="element-4678">
                  {title}
                </h2>
                {description && <p className="text-sm text-gray-500 mt-0.5" data-id="element-4679">{description}</p>}
              </div>
              <button onClick={onClose} className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors flex-shrink-0 ml-4" aria-label="Sluiten" data-id="element-4680">
                <X className="w-5 h-5" data-id="element-4681" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-5 py-5" data-id="element-4682">{children}</div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}